import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Modal from 'react-modal'; 
import { Workbox } from 'workbox-window'; // Librería moderna de Google
import { toast } from 'react-toastify';   

const root = ReactDOM.createRoot(document.getElementById('root'));

Modal.setAppElement('#root'); 

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// --- LÓGICA DE ACTUALIZACIÓN PWA (WORKBOX) ---
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  const wb = new Workbox('/service-worker.js');

  const showUpdatePrompt = () => {
    toast.info(
      <div>
        <div className="fw-bold mb-2">¡Nueva versión disponible! 🎉</div>
        <div className="fs-7 mb-3">Hemos actualizado Top Online.</div>
        <button 
          className="btn btn-sm btn-primary w-100" 
          onClick={() => {
            // Cuando el nuevo SW tome el control, recargamos la página
            wb.addEventListener('controlling', () => {
              window.location.reload();
            });
            // Le decimos al SW nuevo que se active inmediatamente
            wb.messageSkipWaiting();
          }}
        >
          Actualizar ahora
        </button>
      </div>,
      { 
        position: "bottom-right", 
        autoClose: false, // Obliga al usuario a interactuar
        closeOnClick: false, 
        draggable: false
      }
    );
  };

  // Se dispara cuando hay un SW nuevo esperando para instalarse
  wb.addEventListener('waiting', showUpdatePrompt);

  wb.register().catch(err => console.error('Error registrando Service Worker:', err));
}

reportWebVitals();